import clsx from 'clsx';
import { FormDivider } from '../formComponents';

interface OpeningTimesProps {
    openingTimes: {
        sunday: string;
        saturday: string;
        _type: string;
        mondayToFriday: string;
    };
    quoteFormTopMessage: {
        _type: string;
        message: string;
    };
}

const QuoteFormTop = ({
    openingTimes,
}: {
    openingTimes: OpeningTimesProps[];
}) => {
    const { mondayToFriday, saturday, sunday } =
        openingTimes[0].openingTimes || {};

    const formTopMessage =
        openingTimes[0]?.quoteFormTopMessage &&
        openingTimes[0]?.quoteFormTopMessage.message;

    const textClasses = clsx(
        'text-md',
        'text-center',
        'text-red-600',
        'font-bold'
    );

    return (
        <>
            <p className="text-md text-center font-bold">{formTopMessage}</p>

            <FormDivider />

            <p className={textClasses}>
                Opening times:
                <br />
                Monday - Friday: {mondayToFriday},<br />
                Saturday: {saturday}, Sunday: {sunday}.
            </p>

            <p className={`${textClasses} pt-2 text-balance`}>
                There is a key drop facility for out of hours returns.
            </p>

            <FormDivider />
        </>
    );
};

export default QuoteFormTop;
